import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newServiceTypeCreation } from "./serviceTypeAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useNavigate, Link } from 'react-router-dom';
import { getAllServiceType } from "./serviceTypeAction";
import { FaArrowLeft } from 'react-icons/fa';

const initialState = {
    servicetype: "",
    status: "",

}

/* username: "Kavya",
contactno: "1234567890",
email: "kavya@royalarabian.com",
role_id: 1,
password: "asdf1233D@",
confirmPassword: "asdf1233D@",
address: "Mangalore",
address2: "Mangalore",
user_status: 1, */



const CreateServiceType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ServiceTypeRef = useRef(null);
  const [newServiceType, setNewServiceType] = useState(initialState);
  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();
 
  const { stiscLoading, stcstatus, stcMessage } = useSelector((state) => state.serviceTypiesList);
  
  useEffect(() => { }, [newServiceType]);

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
   
    setNewServiceType({ ...newServiceType, [name]: value });

   
 
  };
  useEffect(() => {
    dispatch(getAllServiceType());
   
}, [dispatch,stcMessage]);


  const handleOnSubmit = (e) => {
    e.preventDefault();
    const { servicetype, status
    } = newServiceType;
    const newServiceTypeCreation1 = {
        servicetype,
        status
    };
 
    dispatch(newServiceTypeCreation(newServiceTypeCreation1));
    navigate('/serviceTypeList');
  e.target.reset();
  Swal.fire('Service type Created Successfully!', '', 'success')
  };
  
  const canSave = Boolean(newServiceType.servicetype) && Boolean(newServiceType.status)
  
  return (
    <>
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Service Type</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/serviceTypeList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridServiceType">
                  <Form.Label>Service Type Name</Form.Label>
                  <Form.Control type="text" ref={ServiceTypeRef}  name="servicetype" required="true" autoComplete='off' placeholder="Enter Service Type Name" {...register("servicetype", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.servicetype && <p className='text-danger'> Service Type required</p>}
                </Form.Group>
               
                
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status" , { required: true })} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
                Submit
              </Button>
              </div>
              {stiscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default CreateServiceType;